import cssConstants from './constants';
import mediaQueries from './constants/media-queries';

const Styles = {
  ...cssConstants,
  ...mediaQueries,
};

if (process.env.NODE_ENV === 'development') {
  const _global = typeof window === 'undefined' ? global : window;
  _global.Styles = Styles;
}

export default Styles;
